// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25lKN","col":"styles_col__1UtdA"};